class DumelProduct {
  mainGallery: DumelProductMainGallery;
  youtube: DumelProductYoutube[] = [];
  functions: DumelProductFunctions;
  private adminMode: boolean;
  private element: JQuery;
  private _productId: number;

  constructor(element: JQuery) {
    this.element = element;
    this.adminMode = this.element.find('.cms-dumel-product')[0].hasAttribute('data-edit-mode');
    this._productId = parseInt(this.element.find('.cms-dumel-product').attr('data-dumel-product-id'), 10);
    this.mainGallery = new DumelProductMainGallery(this.element.find('.cms-dumel-product__gallery-main'),
      this.element.find('.cms-dumel-product__gallery-main-pagination'), this.adminMode, this._productId);

    if (this.element.find('.cms-dumel-product__youtube').length > 0) {
      this.element.find('.cms-dumel-product__youtube').each((index, elem) => {
        this.youtube.push(new DumelProductYoutube($(elem)));
      });
    }

    this.functions = new DumelProductFunctions(this.element.find('.cms-dumel-product__functions'));

    if (this.adminMode) {
      const adminModeDumelProductComponent = new novaCmsWidgets.DumelProductComponent(this.element, this);
    }
  }

  get productId() {
    return this._productId;
  }
}

class DumelProductMainGallery {
  private filterProductsIds: Array<{ productId: number; url: string }> = [];
  private productId: number;
  private element: JQuery;
  private parentElement: JQuery;
  private pagination: JQuery;
  private adminMode: boolean;
  private filteredIdsCurrentProductIndex: number;

  constructor(element, pagination, adminMode: boolean, productId: number) {
    this.element = element;
    this.parentElement = element.closest('.cms-dumel-product__galleries');
    this.pagination = pagination;
    this.adminMode = adminMode;
    this.productId = productId;
    this.init();
    this.initSlick();
    this.initEvents();
  }

  init() {
    if (document.referrer.indexOf('/products') < 0) {
      sessionStorage.removeItem('filterProductsIds');
    }

    this.filterProductsIds = this.getProductsFilteredIds() || [];

    if (!this.filterProductsIds.length) {
      const token = $('meta[name="csrf-token"]').attr('content');
      const datasetProduct = new novaCmsDataSets.ProductDataSet(token);
      datasetProduct.readData().then(() => {
        this.filterProductsIds = datasetProduct.dataSource.view().map(prod => {
          const product = (prod as any);
          const productId = product.id;

          return {
            productId,
            url: product.ProductUrl
          };
        });

        this.setFilteredIdsCurrentProductIndex();
      });
    } else {
      this.setFilteredIdsCurrentProductIndex();
    }

  }

  setFilteredIdsCurrentProductIndex() {
    this.filteredIdsCurrentProductIndex = this.filterProductsIds.findIndex(product => product.productId === this.productId);
  }
  addImage(id) {
    this.element.slick('unslick');
    this.pagination.slick('unslick');

    this.element.append(`<div class="cms-dumel-product__gallery-main-item" data-image-id="${id}">
      <img src="/image/${id}" />
    </div>`);

    this.pagination.append(`<div class="cms-dumel-product__gallery-main-pagination-item" data-image-id="${id}">
      <img src="/image/${id}/150/150" class="cms-dumel-product__gallery-main-pagination-item-image"/>
      <div class="cms-dumel-product__gallery-main-pagination-item-remove"></div>
    </div>`);

    this.initSlick();
  }

  removeImage(id) {
    this.element.slick('unslick');
    this.pagination.slick('unslick');

    this.element.find(`.cms-dumel-product__gallery-main-item[data-image-id='${id}']`).remove();
    this.pagination.find(`.cms-dumel-product__gallery-main-pagination-item[data-image-id='${id}']`).remove();

    this.initSlick();
  }

  getGalleryConfig() {
    this.element.slick('unslick');

    if (!this.adminMode) {
      this.pagination.slick('unslick');
    }

    const ids = [];
    this.pagination.find(`.cms-dumel-product__gallery-main-pagination-item`).each((index, element) => {
      ids.push($(element).attr('data-image-id'));
    });

    this.initSlick();

    return {
      ProductGallery: ids
    };
  }

  private getProductsFilteredIds() {
    return JSON.parse(sessionStorage.getItem('filterProductsIds'));
  }

  private initEvents() {
    this.parentElement.find(`.cms-dumel-product__gallery-zoom-button,
      .cms-dumel-product__gallery-zoom-button-close, .cms-dumel-product__gallery-main-item`).click(() => {
        this.parentElement.toggleClass('cms-dumel-product__galleries--zoom');
        (this.element[0] as any).slick.refresh();
        (this.pagination[0] as any).slick.refresh();
        this.element.find('.cms-dumel-product__gallery-main-item').eq(0).focus();
      });
    $('.cms-dumel-product__arrow--prev').click(() => {
      const previousProduct = this.getPreviousId();

      if (previousProduct) {
        this.changeProduct(previousProduct.url);
      }
    });
    $('.cms-dumel-product__arrow--next').click(() => {
      const nextProduct = this.getNextId();

      if (nextProduct) {
        this.changeProduct(nextProduct.url);
      }
    });
  }

  private getPreviousId() {
    if (!this.filterProductsIds.length) {
      return;
    }

    if (this.filteredIdsCurrentProductIndex === 0) {
      return this.filterProductsIds[this.filterProductsIds.length - 1];
    }

    return this.filterProductsIds[this.filteredIdsCurrentProductIndex - 1];
  }

  private getNextId() {
    if (!this.filterProductsIds.length) {
      return;
    }

    if (this.filteredIdsCurrentProductIndex === this.filterProductsIds.length - 1) {
      return this.filterProductsIds[0];
    }

    return this.filterProductsIds[this.filteredIdsCurrentProductIndex + 1];
  }

  private changeProduct(url: string) {
    location.href = url;
  }

  private initSlick() {
    const allImagesLength = this.pagination.find('.cms-dumel-product__gallery-main-pagination-item').length;
    const allowSlickScroll = allImagesLength > 1;

    if (!this.adminMode) {
      this.pagination.addClass('cms-dumel-product__gallery-main-pagination--' + allImagesLength);
    }

    this.element.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 0,
      accessibility: allImagesLength > 1,
      fade: true,
      dots: true,
      arrows: allowSlickScroll,
      swipe: allowSlickScroll,
      prevArrow: `
          <button type="button" class="slick-prev">
            <svg viewBox="0 0 12.1 18.7">
              <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
                c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
                s-0.7-0.1-1-0.4L0.4,10.4z"/>
            </svg>
          </button>
        `,
      nextArrow: `
          <button type="button" class="slick-next">
            <svg viewBox="0 0 12.1 18.7">
              <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
                c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
                s-0.7-0.1-1-0.4L0.4,10.4z"/>W
            </svg>
          </button>
        `,
      asNavFor: '.cms-dumel-product__gallery-main-pagination'
    });

    if (allImagesLength <= 1) {
      this.pagination.hide();
    }

    this.pagination.slick({
      accessibility: allImagesLength > 3,
      slidesToShow: allImagesLength > 3 ? 3 : allImagesLength,
      slidesToScroll: 1,
      focusOnSelect: true,
      variableWidth: true,
      centerMode: allImagesLength > 2,
      prevArrow: `
        <button type="button" class="slick-prev">
        <svg viewBox="0 0 12.1 18.7">
        <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
        c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
        s-0.7-0.1-1-0.4L0.4,10.4z"/>
        </svg>
        </button>
        `,
      nextArrow: `
        <button type="button" class="slick-next">
        <svg viewBox="0 0 12.1 18.7">
        <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
        c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
        s-0.7-0.1-1-0.4L0.4,10.4z"/>
        </svg>
          </button>
          `,
      asNavFor: '.cms-dumel-product__gallery-main'
    });

    if (this.adminMode) {
      this.pagination.addClass('cms-dumel-product__gallery-main-pagination--admin');
      this.pagination.slick('unslick');
      this.pagination.kendoSortable({
        hint: (element) => element.clone().addClass('hint'),
        placeholder: (element) => element.clone().addClass('placeholder')
          .width(element.width()).height(element.height()).text('drop here'),
        cursorOffset: {
          top: 0,
          left: 0
        }
      });
    }
  }
}

class DumelProductYoutube {
  private watchId: string;
  private url: string;
  private element: JQuery;
  private thumbElement: JQuery;
  private videoElement: JQuery;
  private playButton: JQuery;
  private pauseButton: JQuery;
  private isLoaded = false;

  constructor(element: JQuery) {
    this.element = element;

    this.playButton = this.element.find('.cms-dumel-product__button--play');
    this.pauseButton = this.element.find('.cms-dumel-product__button--pause');
    this.thumbElement = this.element.find('.cms-dumel-product__youtube-thumb');
    this.videoElement = this.element.find('.cms-dumel-product__video-yt');

    this.url = this.element.attr('data-url');
    this.watchId = this.getWatchId();
    this.thumbElement.attr('src', `https://img.youtube.com/vi/${this.watchId}/hqdefault.jpg`);

    this.initEvents();
  }

  private initEvents() {
    this.playButton.click(() => {
      if (this.isLoaded) {
        this.playVideo();
      } else {
        this.initPlayer();
      }
    });

    this.videoElement.on('youtubeLinkChange', (e, link) => {
      this.url = link;
      this.thumbElement.attr('src', `https://img.youtube.com/vi/${this.watchId}/sddefault.jpg`);

      if (this.videoElement.data('kendoMediaPlayer')) {
        this.pauseVideo();
        this.videoElement.data('kendoMediaPlayer').media({
          source: this.url
        });
      }
    });

    this.pauseButton.click(() => this.pauseVideo());
  }

  private initPlayer() {
    this.isLoaded = true;
    this.videoElement.kendoMediaPlayer({
      autoPlay: false,
      navigatable: false,
      ready: () => {
        this.videoElement.css('width', '100%');
        this.playVideo();
      },
      end: () => this.pauseVideo(),
      media: {
        source: this.url
      }
    });
  }

  private playVideo() {
    this.thumbElement.addClass('cms-dumel-product__youtube-thumb--hide');
    this.videoElement.data('kendoMediaPlayer').play();
    this.playButton.hide();
    this.pauseButton.show();
  }

  private pauseVideo() {
    this.thumbElement.removeClass('cms-dumel-product__youtube-thumb--hide');
    this.videoElement.data('kendoMediaPlayer').pause();
    this.playButton.show();
    this.pauseButton.hide();
  }

  private getWatchId() {
    if (this.url.indexOf('youtu.be') >= 0) {
      const splitted = this.url.split('/');

      return splitted[splitted.length - 1];
    } else {
      return this.url.split('?v=')[1];
    }
  }
}

interface DumelProductFunctionsPlayer {
  audio: HTMLAudioElement;
  label: JQuery;
}

class DumelProductFunctions {
  private element: JQuery;
  private zoomElement: JQuery;
  private slider: JQuery;
  private showFunctions = true;
  private player: DumelProductFunctionsPlayer;

  constructor(element: JQuery) {
    this.element = element;
    this.slider = this.element.find('.cms-dumel-product__functions-wrap');
    this.initEvents();
    this.initSlider();
    this.initZoom();
    this.initArrows();
    this.initKeys();
  }

  private initZoom() {
    this.element.find('.cms-dumel-product__show-zoom').click(() => {
      this.element.find('.cms-dumel-product__functions-image').toggleClass('-zoom-active');
      $('body').toggleClass('no-scroll');
    });
    $(document).keydown((e) => {
      if (e.keyCode === 27 && this.element.find('.cms-dumel-product__functions-image').hasClass('-zoom-active')) {
        this.element.find('.cms-dumel-product__functions-image').toggleClass('-zoom-active');
        $('body').toggleClass('no-scroll');
      }
    });
  }

  private initSlider() {
    this.slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      prevArrow: `
          <button type="button" class="slick-prev">
            <svg viewBox="0 0 12.1 18.7">
              <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
                c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
                s-0.7-0.1-1-0.4L0.4,10.4z"/>
            </svg>
          </button>
        `,
      nextArrow: `
          <button type="button" class="slick-next">
            <svg viewBox="0 0 12.1 18.7">
              <path fill="currentColor" d="M0.4,10.4C0.1,10.1,0,9.8,0,9.4c0-0.4,0.1-0.7,0.4-1l8-8C8.7,0.1,9,0,9.4,0s0.7,0.1,1,0.4l1.3,1.3
                c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1L6,9.4l5.6,5.6c0.3,0.3,0.4,0.6,0.4,1s-0.1,0.7-0.4,1l-1.3,1.3c-0.3,0.3-0.6,0.4-1,0.4
                s-0.7-0.1-1-0.4L0.4,10.4z"/>
            </svg>
          </button>
        `,
    });
  }

  private initArrows() {
    this.element.find('.slick-prev').click(() => {
      this.animate();
    });
    this.element.find('.slick-next').click(() => {
      this.animate();
    });
  }
  private initKeys() {
    $(document).keydown((e) => {
      if (e.keyCode === 37) {
        this.animate();
      }
  });
  $(document).keydown((e) => {
      if (e.keyCode === 39) {
        this.animate();
      }
    });
  }
  private initEvents() {
    this.slider.on('init', () => this.animate());
    this.slider.on('beforeChange', () => {
      this.pauseAudio();
      this.player = null;
    });
    this.slider.on('swipe', () => this.animate());

    this.element.find('.cms-dumel-product__toggle, .cms-dumel-product__functions-hide').click((event) => {
      this.toggleFunctionButton($(event.delegateTarget));
    });

    this.element.find('.cms-dumel-product__function-audio').click((event) => {
      this.player = {
        audio: $(event.delegateTarget).find('.cms-dumel-product__function-audio-file')[0] as HTMLAudioElement,
        label: $(event.delegateTarget).find('.cms-dumel-product__function-audio-label')
      };

      $(this.player.audio).off().on('ended', () => this.pauseAudio());

      if (this.player.audio.paused) {
        this.playAudio();
      } else {
        this.pauseAudio();
      }
    });
  }

  private toggleFunctionButton(element) {
    if (this.showFunctions) {
      this.showFunctionsElement(element);
    } else {
      this.hideFunctionsElement(element);
    }

    if (this.player && !this.player.audio.paused) {
      this.pauseAudio();
    }
  }

  private showFunctionsElement(element) {
    this.showFunctions = false;
    this.animate(true);
    this.element.find('.cms-dumel-product__toggle').show();
    this.element.find('.cms-dumel-product__function-point').hide();
  }

  private hideFunctionsElement(element) {
    this.showFunctions = true;
    this.animate(false);
    this.element.find('.cms-dumel-product__toggle').hide();
    this.element.find('.cms-dumel-product__function-point').show();
  }

  private animate(startPos?: boolean) {
    let x: number;
    let y: number;

    if (startPos) {
      x = y = 50;
    } else {
      x = parseInt(this.slider.find('.slick-current').attr('data-x'), 10);
      y = parseInt(this.slider.find('.slick-current').attr('data-y'), 10);
    }

    this.slider.parent().next('.cms-dumel-product__function-img').animate({
      top: y + '%',
      left: x + '%'
    }, 300);
  }

  private playAudio() {
    if (this.player) {
      this.player.audio.play();
      this.player.label.text('zatrzymaj dźwięk');
    }
  }

  private pauseAudio() {
    if (this.player) {
      this.player.audio.pause();
      this.player.label.text('odtwórz dźwięk');
    }
  }
}

$(document).ready(() => {
  $('dumel-product').each((index, product) => {
    const Product = new DumelProduct($(product));
  });
});
